"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalizedContext = exports.PersonalizationProvider = exports.PersonalizationContextBindingProvider = exports.Debugger = void 0;
exports.findVehicleInList = findVehicleInList;
exports.useVhrAndServiceHistoryContext = exports.useVehicleServiceHistoryContext = exports.useVehicleManualsContext = exports.useVehicleHealthReportContext = exports.useVehicleGuides = exports.useTechQuickGuidesContext = exports.useSafetyServiceAlertsContext = exports.usePersonalizedContext = exports.usePersonalizedApiCall = exports.usePersonalizationFunctions = exports.useMyLexusVehicleManualsContext = exports.useIsLoggedIn = exports.useIsAuthenticated = exports.useHasWifiContext = exports.useHasDefaultVehicleWithVin = exports.useGarageVehicles = exports.useEosApi = exports.useDriversPreferredVehicle = exports.useDefaultVehicle = exports.useDefaultHook = exports.useAllVehicleSubscriptionsContext = void 0;
var _lodashEs = require("lodash-es");
var _react = _interopRequireWildcard(require("react"));
var _Cookie = _interopRequireDefault(require("../Cookie"));
var _useQueryParams2 = _interopRequireDefault(require("../useQueryParams"));
require("reactjs-json-editor/css/style.css");
var _useRawVehicleHealthReportByVin = _interopRequireDefault(require("../../_nextgen/store/vehicle/useRawVehicleHealthReportByVin"));
var _useRawVehicleSafetyCampaignsByVin = _interopRequireDefault(require("../../_nextgen/store/vehicle/useRawVehicleSafetyCampaignsByVin"));
var _dcs = require("../../api/dcs3");
var _useUserRepository = _interopRequireDefault(require("../../api/dcs3/useUserRepository"));
var _eos = require("../../api/eos");
var _productMap = require("../../api/eos/productMap");
var _jsxRuntime = require("react/jsx-runtime");
const PersonalizedContext = exports.PersonalizedContext = /*#__PURE__*/_react.default.createContext({});
function getModelFromTrim() {
  let trim = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return trim === null || trim === void 0 ? void 0 : trim.replace(/([0-9\s]+)/g, "");
}
const useEosApi = function (userData) {
  var _vehicles$;
  const isInitialLoadingUser = userData === null || userData === void 0 ? void 0 : userData.isInitialLoadingUser;
  const [eosData, setEosData] = (0, _react.useState)({
    isInitialLoadingUser
  });
  const hasUserData = Object.keys(userData || {}).length > 0 && (typeof userData.firstName !== "undefined" || typeof userData.organizationName !== "undefined");
  const isLoggedIn = useIsLoggedIn(userData);
  const {
    vehicles,
    isInitialLoadingUserVehicles,
    status: eosStatus
  } = (0, _eos.useGetUserVehicles)(hasUserData);
  const {
    year = "",
    model = "",
    vin = ""
  } = useDriversPreferredVehicle(hasUserData);
  const [cookie, setCookie] = (0, _Cookie.default)("drivers-default-vehicle");
  const defaultVehicleObject = cookie ? {} : {
    defaultVehicleString: `${year} ${model}`,
    defaultVehicle: {
      year,
      model: getModelFromTrim(model),
      trim: model,
      vin
    }
  };
  const hasImage = vehicles === null || vehicles === void 0 ? void 0 : (_vehicles$ = vehicles[0]) === null || _vehicles$ === void 0 ? void 0 : _vehicles$.jellyImage;
  (0, _react.useMemo)(function () {
    if (!isLoggedIn) {
      return;
    }
    setEosData({
      isLoggedIn: isLoggedIn,
      isInitialLoadingUser,
      isInitialLoadingUserVehicles,
      eosStatus,
      vehicles: vehicles.map(function (v) {
        var _v$jellyImage, _v$banner;
        return {
          make: v.make,
          model: v.model,
          year: v.year,
          vin: v.vin,
          yearModelTrimString: `${v.year} ${v.model}`,
          vehicleId: v.vehicleId,
          nickName: v.nickName,
          preferredVehicle: v.preferredVehicle,
          exteriorColorCode: v === null || v === void 0 ? void 0 : v.exteriorColorCode,
          jelly: v === null || v === void 0 ? void 0 : (_v$jellyImage = v.jellyImage) === null || _v$jellyImage === void 0 ? void 0 : _v$jellyImage.vehicleImage,
          banner: v === null || v === void 0 ? void 0 : (_v$banner = v.banner) === null || _v$banner === void 0 ? void 0 : _v$banner.desktopImage,
          homeDealerCode: v === null || v === void 0 ? void 0 : v.homeDealerCode,
          preferredDealer: v === null || v === void 0 ? void 0 : v.preferredDealer,
          preferredDealerCode: v === null || v === void 0 ? void 0 : v.preferredDealerCode,
          driveType: v === null || v === void 0 ? void 0 : v.driveType,
          description: v === null || v === void 0 ? void 0 : v.description
        };
      }),
      ...defaultVehicleObject
    });
  }, [isLoggedIn, vehicles.length, hasImage, year, model, vin, isInitialLoadingUser, isInitialLoadingUserVehicles]);
  return eosData;
};
exports.useEosApi = useEosApi;
const PersonalizationProvider = exports.PersonalizationProvider = (0, _eos.withEOSProvider)((0, _dcs.withDCS3Provider)(function (_ref) {
  var _data$postalAddresses;
  let {
    children,
    ...props
  } = _ref;
  const params = useSetupParams();
  const [id_token] = (0, _Cookie.default)("id_token");
  const [id_token_local] = (0, _Cookie.default)("id_token_local");
  const [id_token_tmnab2cqa] = (0, _Cookie.default)("id_token_tmnab2cqa");
  const {
    user: data = {},
    isInitialLoadingUser
  } = (0, _useUserRepository.default)(typeof (id_token || id_token_local || id_token_tmnab2cqa) !== "undefined");
  const eosData = useEosApi({
    ...data,
    isInitialLoadingUser
  });
  const [cookie, setCookie] = (0, _Cookie.default)("drivers-default-vehicle");
  const [defaultVehicle, setDefaultVehicle] = (0, _react.useState)(cookie);
  const [year, ...modelArr] = (defaultVehicle || "").split(" ");
  const [trim, vin = null] = ((modelArr === null || modelArr === void 0 ? void 0 : modelArr.join(" ")) || "").split("/");
  const model = getModelFromTrim(trim);
  const user = {
    // personal: data,
    firstName: data === null || data === void 0 ? void 0 : data.firstName,
    lastName: data === null || data === void 0 ? void 0 : data.lastName,
    organizationName: data === null || data === void 0 ? void 0 : data.organizationName,
    phone: data === null || data === void 0 ? void 0 : data.telephoneNumber,
    customerType: data === null || data === void 0 ? void 0 : data.customerType,
    address: data === null || data === void 0 ? void 0 : (_data$postalAddresses = data.postalAddresses) === null || _data$postalAddresses === void 0 ? void 0 : _data$postalAddresses[0],
    customerCentralId: data === null || data === void 0 ? void 0 : data.customerCentralId,
    tmsGuid: data === null || data === void 0 ? void 0 : data.tmsGuid,
    defaultVehicle: {},
    defaultVehicleString: ""
  };
  const userDefaultVehicle = cookie ? {
    defaultVehicleString: (defaultVehicle || "").split("/")[0],
    defaultVehicle: {
      year,
      trim,
      model,
      vin: id_token ? vin : undefined
    }
  } : {};
  const [debuggerData, setDebuggerData] = (0, _react.useState)({});
  const formattedParams = {
    ...params
  };
  if (params["defaultVehicleString"]) {
    const [year, trim] = params["defaultVehicleString"].split(" ");
    formattedParams.defaultVehicle = {
      year,
      trim,
      model: getModelFromTrim(trim)
    };
  }
  if (params["defaultVehicle"]) {
    formattedParams.defaultVehicleString = `${params["defaultVehicle"]["year"]} ${params["defaultVehicle"]["trim"] || params["defaultVehicle"]["model"]}`;
    if (!params["defaultVehicle"]["model"] && params["defaultVehicle"]["trim"]) {
      formattedParams.defaultVehicle.model = getModelFromTrim(params["defaultVehicle"]["trim"]);
    }
  }
  const mergedData = (0, _lodashEs.merge)(props, user, eosData, userDefaultVehicle, formattedParams, debuggerData);
  const functions = {
    setDefaultVehicle: function (v, vin) {
      const decodedTrim = decodeURIComponent(v);
      const value = vin ? `${decodedTrim}/${vin}` : decodedTrim;
      setDefaultVehicle(value);
      setCookie(value);
    }
  };
  window.onpagehide = function () {
    typeof (id_token || id_token_local) !== "undefined" && setCookie("");
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(PersonalizedContext.Provider, {
    value: {
      data: mergedData,
      functions
    },
    "data-testid": "PersonalizationProvider",
    children: children
  });
}));
const usePersonalizedContext = function () {
  return (0, _react.useContext)(PersonalizedContext).data;
};
exports.usePersonalizedContext = usePersonalizedContext;
const usePersonalizationFunctions = function () {
  return (0, _react.useContext)(PersonalizedContext).functions || {};
};
exports.usePersonalizationFunctions = usePersonalizationFunctions;
const Debugger = function (props) {
  var _useQueryParams;
  const {
    debug
  } = ((_useQueryParams = (0, _useQueryParams2.default)()) === null || _useQueryParams === void 0 ? void 0 : _useQueryParams.p) || {};
  const [showing, setShowing] = (0, _react.useState)(false);
  return debug === "true" && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      onClick: function () {
        return setShowing(!showing);
      },
      style: {
        position: "absolute",
        right: "10px",
        cursor: "pointer",
        zIndex: "99999"
      },
      children: showing ? "close" : "debug"
    }), showing && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        position: "fixed",
        bottom: "0",
        zIndex: "9999",
        background: "rgba(0,0,0,0.8)",
        color: "#FFF",
        padding: "10px",
        left: "0",
        height: "100%",
        boxSizing: "border-box",
        maxWidth: "90%",
        overflow: "scroll"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("pre", {
        style: {
          fontSize: "14px"
        },
        children: JSON.stringify(props, " ", 2)
      })
    })]
  });
};
exports.Debugger = Debugger;
const PersonalizationContextBindingProvider = function (_ref2) {
  let {
    children,
    ...props
  } = _ref2;
  // const proxyProps = {
  //   authorizationType: 'authenticated',
  //   excludedModelYears: [{model: "LC", year: "2021"}],
  // }
  /* eslint-disable-next-line */
  const {
    apiContext,
    hideEmptyContext = false,
    ...extras
  } = props;
  const isAuth = useIsAuthenticated(props);
  const {
    data,
    functions
  } = (0, _react.useContext)(PersonalizedContext);
  const apiData = usePersonalizedApiCall(apiContext)() || {};
  const hasData = apiData._isEmpty !== true;
  const onlyRenderIfApiDataHasData = hideEmptyContext && apiContext && !(apiData !== null && apiData !== void 0 && apiData._isLoading) ? hasData : true;
  const render = isAuth && onlyRenderIfApiDataHasData;
  if (!render) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
  const mergedData = {
    ...data,
    ...(apiData || {}),
    apiContext
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(PersonalizedContext.Provider, {
    value: {
      functions,
      data: mergedData
    },
    "data-testid": "PersonalizationContextBindingProvider",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Debugger, {
      ...mergedData
    }), children]
  });
};
exports.PersonalizationContextBindingProvider = PersonalizationContextBindingProvider;
const useGarageVehicles = function () {
  const {
    vehicles = []
  } = usePersonalizedContext() || {};
  return vehicles || [];
};
exports.useGarageVehicles = useGarageVehicles;
const useDriversPreferredVehicle = function (hasUserData) {
  const {
    vehicles
  } = (0, _eos.useGetUserVehicles)(hasUserData);
  return vehicles.find(function (i) {
    return i.preferredVehicle === "Y";
  }) || {};
};
exports.useDriversPreferredVehicle = useDriversPreferredVehicle;
const useDefaultVehicle = function () {
  const {
    defaultVehicle,
    defaultVehicleString = undefined,
    isInitialLoadingUserVehicles
  } = usePersonalizedContext() || {};
  return {
    defaultVehicle,
    defaultVehicleString,
    isInitialLoadingUserVehicles
  };
};
exports.useDefaultVehicle = useDefaultVehicle;
const useIsLoggedIn = function () {
  let userData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const data = usePersonalizedContext() || userData;
  // const [cookie] = Cookie('isLoggedIn'); // Cookie stays true even when session expires, so shouldn't be used
  return typeof data.firstName !== "undefined" && data.firstName !== "" || typeof data.organizationName !== "undefined" && data.organizationName !== "";
};
exports.useIsLoggedIn = useIsLoggedIn;
function findVehicleInList(vehicle) {
  let list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let preferred = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return list.find(function (i) {
    var _i$model, _vehicle$model, _i$model2, _vehicle$model2;
    return preferred ? String(i.year) === String(vehicle === null || vehicle === void 0 ? void 0 : vehicle.year) && (((_i$model = i.model) === null || _i$model === void 0 ? void 0 : _i$model.toLowerCase()) === (vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$model = vehicle.model) === null || _vehicle$model === void 0 ? void 0 : _vehicle$model.toLowerCase()) || i.model === "*") && i.preferredVehicle === "Y" : String(i.year) === String(vehicle === null || vehicle === void 0 ? void 0 : vehicle.year) && (((_i$model2 = i.model) === null || _i$model2 === void 0 ? void 0 : _i$model2.toLowerCase()) === (vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$model2 = vehicle.model) === null || _vehicle$model2 === void 0 ? void 0 : _vehicle$model2.toLowerCase()) || i.model === "*");
  });
}

/// These props should be changed so they don't overlap
const useIsAuthenticated = function (_ref3) {
  let {
    authorizationType,
    modelYears = [],
    excludedModelYears = []
  } = _ref3;
  const {
    vehicles = []
  } = usePersonalizedContext() || {};
  const {
    defaultVehicle
  } = useDefaultVehicle();
  const isAuthenticated = useIsLoggedIn();
  const {
    editorMode = false
  } = window || {};
  if (editorMode) {
    return true;
  }
  if (modelYears.length > 0) {
    const whitelist = findVehicleInList(defaultVehicle, modelYears);
    if (!whitelist) {
      return false;
    }
  }
  if (excludedModelYears.length > 0) {
    const blacklist = findVehicleInList(defaultVehicle, excludedModelYears);
    if (blacklist) {
      return false;
    }
  }
  if (authorizationType === "authenticated") {
    if (!isAuthenticated) {
      return false;
    }
    return true;
  }
  if (authorizationType === "no-vehicles") {
    // defaultVehicle from users garage or from model year form
    return !(defaultVehicle !== null && defaultVehicle !== void 0 && defaultVehicle.year) && !(defaultVehicle !== null && defaultVehicle !== void 0 && defaultVehicle.trim);
  }
  if (authorizationType === "unauthenticated" && isAuthenticated) {
    return false;
  }
  return true;
};

/* Context Strings Below */
exports.useIsAuthenticated = useIsAuthenticated;
const useDefaultHook = function () {
  return {};
};
exports.useDefaultHook = useDefaultHook;
const useVehicleHealthReportContext = function () {
  var _currentMileage$toLoc, _Number, _Number$toLocaleStrin;
  const {
    vin = ""
  } = usePersonalizedContext().defaultVehicle;
  const {
    isLoading,
    data
  } = (0, _useRawVehicleHealthReportByVin.default)(vin, {
    select: function (response) {
      return (response === null || response === void 0 ? void 0 : response.data) || {};
    }
  });
  const {
    maintenanceInformation,
    vehicleStatus,
    safetyRecalls,
    serviceCampaigns
  } = data || {};
  if (!maintenanceInformation) {
    return {
      _isEmpty: true
    };
  }
  const {
    currentMileageUnit,
    currentMileage,
    currentServiceMileage,
    currentServiceMileageUnit,
    currentServiceTime,
    currentServiceTimeUnit
  } = maintenanceInformation;
  const {
    milesToEmptyDescription,
    engineOilLevelDescription,
    oilDegradationDescription,
    oilDegradationStatus,
    engineOilLevelStatus
  } = vehicleStatus;
  const formattedCurrentMileage = currentMileage === null || currentMileage === void 0 ? void 0 : (_currentMileage$toLoc = currentMileage.toLocaleString) === null || _currentMileage$toLoc === void 0 ? void 0 : _currentMileage$toLoc.call(currentMileage, "en-US");
  const formattedCurrentServiceMileage = (_Number = Number(currentServiceMileage)) === null || _Number === void 0 ? void 0 : (_Number$toLocaleStrin = _Number.toLocaleString) === null || _Number$toLocaleStrin === void 0 ? void 0 : _Number$toLocaleStrin.call(_Number, "en-US");
  const oilQuality = function (status) {
    let result;
    if (status === 0) {
      result = "POOR";
    } else if (status > 0 && status <= 2) {
      result = "GOOD";
    } else if (status === 3) {
      result = "EXCELLENT";
    }
    return result;
  };
  const engineLevel = function (status) {
    let result;
    if (status === 0) {
      result = "LOW";
    } else if (status > 0 && status <= 2) {
      result = "MID";
    } else if (status === 3) {
      result = "FULL";
    }
    return result;
  };
  return {
    _isLoading: isLoading,
    _isEmpty: false,
    vhrSummary: {
      milesToEmpty: milesToEmptyDescription,
      milesDriven: `${formattedCurrentMileage} ${currentMileageUnit}s`.toUpperCase(),
      recommendedServiceMiles: `${formattedCurrentServiceMileage} ${currentServiceMileageUnit}`.toUpperCase(),
      recommendedServiceTime: `${currentServiceTime} ${currentServiceTimeUnit}`.toUpperCase(),
      numOfSafetyRecalls: (safetyRecalls === null || safetyRecalls === void 0 ? void 0 : safetyRecalls.safetyRecallList.length) || 0,
      numOfServiceCampaigns: (serviceCampaigns === null || serviceCampaigns === void 0 ? void 0 : serviceCampaigns.serviceCampaignsList.length) || 0,
      engineOilLevelDescription,
      engineOilLevelStatus: engineLevel(engineOilLevelStatus),
      oilDegradationDescription,
      oilDegradationStatus: oilQuality(oilDegradationStatus),
      currentMileage
    },
    vhr: {
      ...maintenanceInformation,
      ...vehicleStatus
    }
  };
};
exports.useVehicleHealthReportContext = useVehicleHealthReportContext;
const useVehicleServiceHistoryContext = function () {
  const {
    vin = ""
  } = usePersonalizedContext().defaultVehicle;
  const {
    data = {},
    isLoading
  } = (0, _eos.useGetVehicleServiceHistory)(vin);
  const {
    serviceHistoryRecords,
    repairOrders
  } = data;
  const consolidateData = [...serviceHistoryRecords.map(function (i) {
    var _i$serviceDate;
    return {
      editId: i.memberServiceHistoryId,
      _miles: i.mileage,
      miles: `${i.mileage} miles`,
      date: new Date((_i$serviceDate = i.serviceDate) === null || _i$serviceDate === void 0 ? void 0 : _i$serviceDate.replaceAll("-", "/")).toLocaleDateString(),
      repairNum: i.repairOrderNum,
      reportedBy: i.serviceProvider,
      services: i.memberServiceHistoryDetails.map(function (j) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
          "data-testid": "consolidateData",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: "SERVICE: "
          }), j.serviceCategory, /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: "DESCRIPTION:"
          }), " ", j.serviceCategoryDesc, j.serviceOther && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
              children: "COMMENTS:"
            }), " ", j.serviceOther]
          })]
        });
      }),
      _data: i
    };
  }), ...repairOrders.map(function (i) {
    var _i$dealer;
    return {
      _miles: i.miles,
      miles: `${i.miles} miles`,
      date: new Date(i.postedDate).toLocaleDateString(),
      repairNum: i.repairOrderNumber,
      reportedBy: i === null || i === void 0 ? void 0 : (_i$dealer = i.dealer) === null || _i$dealer === void 0 ? void 0 : _i$dealer.dealerName,
      services: i.repairOrderConditions.map(function (j) {
        return j.operation.map(function (k) {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            "data-testid": "consolidateData",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
              children: "SERVICE: "
            }), k.opCodeDescription, /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
              children: "DESCRIPTION:"
            }), " ", k.serviceOperationDescription.replace(k.opCodeDescription, "")]
          });
        });
      }),
      _data: i
    };
  })].sort(function (a, b) {
    return parseInt(b._miles) - parseInt(a._miles);
  });
  return {
    _isLoading: isLoading,
    _isEmpty: !((consolidateData === null || consolidateData === void 0 ? void 0 : consolidateData.length) > 0),
    serviceHistoryRecords: consolidateData || []
  };
};
exports.useVehicleServiceHistoryContext = useVehicleServiceHistoryContext;
function transformVehicleManuals(manuals, path, vehicleData) {
  const vehicleAppend = vehicleData ? `&model=${vehicleData.model}&year=${vehicleData.year}` : "";
  if (!manuals) {
    return [];
  }
  const manualFormats = {
    PDF: [],
    HTML: []
  };
  manuals.forEach(function (manual) {
    return manualFormats[manual.documents[0].format].push({
      link: manual.documents[0].format === "PDF" ? manual.documents[0].contentLink : path + manual.pubNumber + vehicleAppend,
      title: manual.pubTitle.toUpperCase(),
      pubNumber: manual.pubNumber
    });
  });
  return manualFormats;
}
const useSetupParams = function () {
  const queryParams = (0, _useQueryParams2.default)() || {};
  const params = {
    ...(queryParams === null || queryParams === void 0 ? void 0 : queryParams.p)
  };
  if (queryParams.model && queryParams.year) {
    params.defaultVehicle = {
      trim: queryParams.model,
      year: queryParams.year
    };
  }
  return params;
};
const useVehicleManualsContext = function () {
  let path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/drivers/resources/manual?pubNumber=";
  const params = useSetupParams();
  const personalizationContext = usePersonalizedContext();
  const {
    trim,
    year,
    vin
  } = params.defaultVehicle ? params.defaultVehicle : personalizationContext === null || personalizationContext === void 0 ? void 0 : personalizationContext.defaultVehicle;
  const {
    data: manuals,
    isFetching
  } = (0, _eos.useGetVehicleManuals)({
    model: trim,
    year,
    vin
  });
  const ret = (0, _react.useMemo)(function () {
    return manuals ? {
      _isLoading: false,
      warrantyGuides: transformVehicleManuals(manuals.warrantyGuides, path, {
        model: trim,
        year
      }),
      omotaOwnersManualOverTheAir: transformVehicleManuals(manuals.omotaOwnersManualOverTheAir, path, {
        model: trim,
        year
      }),
      navigationManuals: transformVehicleManuals(manuals.navigationManuals, path, {
        model: trim,
        year
      }),
      ownerManuals: transformVehicleManuals(manuals.ownerManuals, path, {
        model: trim,
        year
      })
    } : {
      _isEmpty: !manuals,
      _isLoading: isFetching
    };
  }, [trim, year, vin, isFetching, manuals]);
  return ret;
};
exports.useVehicleManualsContext = useVehicleManualsContext;
const useMyLexusVehicleManualsContext = function () {
  return useVehicleManualsContext("/My-Lexus/resources/manual?pubNumber=");
};
exports.useMyLexusVehicleManualsContext = useMyLexusVehicleManualsContext;
const useTechQuickGuidesContext = function () {
  var _usePersonalizedConte, _data$data;
  const {
    model,
    year
  } = (_usePersonalizedConte = usePersonalizedContext()) === null || _usePersonalizedConte === void 0 ? void 0 : _usePersonalizedConte.defaultVehicle;
  const {
    data
  } = (0, _eos.useGetVehicleGuides)({
    model,
    year
  });
  const responseCode = data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.status;
  if (responseCode !== 204) {
    if (data !== null && data !== void 0 && data.technologyGuideSource) {
      return {
        techQuickGuide: data === null || data === void 0 ? void 0 : data.technologyGuideSource
      };
    }
    return {
      _isEmpty: true
    };
  }
  return {
    _isEmpty: true
  };
};
exports.useTechQuickGuidesContext = useTechQuickGuidesContext;
const useVehicleGuides = function () {
  var _usePersonalizedConte2, _data$data2;
  const {
    model,
    year
  } = (_usePersonalizedConte2 = usePersonalizedContext()) === null || _usePersonalizedConte2 === void 0 ? void 0 : _usePersonalizedConte2.defaultVehicle;
  const {
    data
  } = (0, _eos.useGetVehicleGuides)({
    model,
    year
  });
  const responseCode = data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.status;
  return responseCode !== 204 ? {
    techQuickGuide: data === null || data === void 0 ? void 0 : data.technologyGuideSource,
    lps: data === null || data === void 0 ? void 0 : data.lpsSource
  } : {
    _isEmpty: true
  };
};
exports.useVehicleGuides = useVehicleGuides;
function mergeSafetyRecallCampaigns(recalls) {
  let campaigns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const recallItems = ((recalls === null || recalls === void 0 ? void 0 : recalls.safetyRecallList) || []).map(function (i) {
    return {
      title: i.Title,
      description: "",
      date: new Date(i.CampaignDate).toLocaleDateString(),
      _data: i
    };
  });
  const campaignItems = campaigns.map(function (i) {
    return {
      title: i.campaignTitle,
      description: i.activityDescription,
      date: new Date(i.releaseDate).toLocaleDateString(),
      _data: i
    };
  });
  return [...recallItems, ...campaignItems];
}
const useSafetyServiceAlertsContext = function () {
  const {
    vin = ""
  } = usePersonalizedContext().defaultVehicle;
  const {
    isLoading,
    data
  } = (0, _useRawVehicleHealthReportByVin.default)(vin, {
    select: function (response) {
      return (response === null || response === void 0 ? void 0 : response.data) || {};
    }
  });
  const {
    data: safetyCampaigns = []
  } = (0, _useRawVehicleSafetyCampaignsByVin.default)(vin, {
    select: function (response) {
      if (!response) return undefined;
      return response.body.data.vehicleCampaignList;
    }
  });
  const {
    vehicleAlerts: vA,
    safetyRecalls: sR,
    serviceCampaigns: sC
  } = data || {};
  const safetyRecallCampaigns = mergeSafetyRecallCampaigns(sR, safetyCampaigns);
  const vehicleAlerts = ((vA === null || vA === void 0 ? void 0 : vA.vehicleAlertList) || []).map(function (i) {
    return {
      name: i.WNGName,
      title: i.WNGName,
      date: new Date(i.WNGDate).toLocaleDateString(),
      description: i.WNGDesc
    };
  });
  const safetyRecalls = (sR === null || sR === void 0 ? void 0 : sR.safetyRecallList) || [];
  const serviceCampaigns = (sC === null || sC === void 0 ? void 0 : sC.serviceCampaignsList) || [];
  if (!vehicleAlerts && !safetyRecalls && !serviceCampaigns) return {};
  return {
    _isLoading: isLoading,
    _isEmpty: !(!!vehicleAlerts.length && !!safetyRecalls.length && !!serviceCampaigns.length),
    safetyServiceAlerts: {
      numOfVehicleAlerts: vehicleAlerts.length,
      numOfSafetyRecalls: safetyRecalls.length,
      numOfServiceCampaigns: serviceCampaigns.length,
      numOfsafetyCampaigns: safetyCampaigns.length,
      numOfSafetyRecallCampaigns: safetyRecallCampaigns.length,
      vehicleAlerts,
      safetyRecalls,
      serviceCampaigns,
      safetyCampaigns,
      safetyRecallCampaigns
    }
  };
};
exports.useSafetyServiceAlertsContext = useSafetyServiceAlertsContext;
const useAllVehicleSubscriptionsContext = function () {
  const {
    vin = ""
  } = usePersonalizedContext().defaultVehicle;
  const {
    data,
    isLoading
  } = (0, _eos.useGetAllVehicleSubscriptions)() || {};
  const vinSubscription = data === null || data === void 0 ? void 0 : data[vin];
  const features = (0, _productMap.getFeatures)(vinSubscription === null || vinSubscription === void 0 ? void 0 : vinSubscription.sxmProductList);
  return {
    _isLoading: isLoading,
    vinSubscription,
    features
  };
};
exports.useAllVehicleSubscriptionsContext = useAllVehicleSubscriptionsContext;
const useHasWifiContext = function () {
  const {
    vin = ""
  } = usePersonalizedContext().defaultVehicle;
  const {
    isLoading,
    data
  } = (0, _eos.useVehicleSpecifications)(vin);
  const {
    VehicleSpecDetailResponse
  } = data || {};
  const enabled = (VehicleSpecDetailResponse === null || VehicleSpecDetailResponse === void 0 ? void 0 : VehicleSpecDetailResponse.hotSpotWifiCapability) === "Y";
  return {
    _isLoading: isLoading,
    _isEmpty: !enabled,
    hasWifi: enabled,
    wifi: {
      enabled,
      imei: VehicleSpecDetailResponse === null || VehicleSpecDetailResponse === void 0 ? void 0 : VehicleSpecDetailResponse.imei,
      meid: VehicleSpecDetailResponse === null || VehicleSpecDetailResponse === void 0 ? void 0 : VehicleSpecDetailResponse.meid
    }
  };
};
exports.useHasWifiContext = useHasWifiContext;
const useHasDefaultVehicleWithVin = function () {
  const {
    vin = ""
  } = usePersonalizedContext().defaultVehicle;
  const hasVin = vin.length > 0;
  return {
    _isEmpty: !hasVin,
    hasVin
  };
};
exports.useHasDefaultVehicleWithVin = useHasDefaultVehicleWithVin;
const useVhrAndServiceHistoryContext = function () {
  const vhrData = useVehicleHealthReportContext();
  const serviceHistoryData = useVehicleServiceHistoryContext();
  return {
    ...vhrData,
    ...serviceHistoryData,
    _isEmpty: (vhrData === null || vhrData === void 0 ? void 0 : vhrData._isEmpty) && (serviceHistoryData === null || serviceHistoryData === void 0 ? void 0 : serviceHistoryData._isEmpty),
    _isLoading: false
  };
};
exports.useVhrAndServiceHistoryContext = useVhrAndServiceHistoryContext;
const usePersonalizedApiCall = function (context) {
  switch (context) {
    case "vehicle-manuals":
      return useVehicleManualsContext;
    case "mylexus-vehicle-manuals":
      return useMyLexusVehicleManualsContext;
    case "vehicle-service-history":
      return useVehicleServiceHistoryContext;
    case "vehicle-health-report":
      return useVehicleHealthReportContext;
    case "safety-service-alerts":
      return useSafetyServiceAlertsContext;
    case "subscriptions":
      return useAllVehicleSubscriptionsContext;
    case "has-wifi":
      return useHasWifiContext;
    case "has-vin":
      return useHasDefaultVehicleWithVin;
    case "vehicle-guides":
      return useVehicleGuides;
    case "tech-quick-guides":
      return useTechQuickGuidesContext;
    case "vhr-and-service-history":
      return useVhrAndServiceHistoryContext;
    default:
      return useDefaultHook;
  }
};
exports.usePersonalizedApiCall = usePersonalizedApiCall;